const EMAIL_PATTERN =
  /[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+/i;

const decodeForPiiCheck = (value: string): string | null => {
  let decoded = value;
  for (let attempt = 0; attempt < 2 && decoded.includes("%"); attempt += 1) {
    try {
      decoded = decodeURIComponent(decoded);
    } catch {
      return null;
    }
  }
  return decoded.includes("%") ? null : decoded;
};

export const containsPostHogEmail = (value: string): boolean => {
  const decoded = decodeForPiiCheck(value);
  return decoded === null || EMAIL_PATTERN.test(decoded);
};
